module.exports = __webpack_public_path__ + "assets/img/arrow-back-blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-back-blue.png
// module id = 213
// module chunks = 0